@let evenement = evenement$ | async;

@if(evenement){

<header
    [ngStyle]="{'background-image': 'url(' + apiUrl +  (evenement.gallery[0].url || '/assets/default-event.jpg') + ')'}"
    class="header">

    @if(evenement.complet) {
    <div class="banner-evenement-complet">complet</div>
    }

    <h1>{{ evenement?.titre }}</h1>
    <app-themes-wrapper [themes]="evenement.themes"></app-themes-wrapper>

    <div class="address">
        {{ evenement?.lieu?.adresse }}, {{ evenement?.lieu?.codePostal }} {{ evenement?.lieu?.ville }}
    </div>

    <div class="participants">
        <p class="min">min : {{ evenement.participantsMin }}</p>
        <p class="max">max : {{ evenement.participantsMax}}</p>
        <p class="totale">total : {{ evenement.participants }}</p>
    </div>

</header>



<div class="content">
    <p>{{evenement.descriptionCourte}}</p>
</div>

}